/** 工程清单共享状态同步：进入页面、返回浏览器及可见页面每分钟读取一次项目。
 * 设计同事重新移交后无需工程经理手动取消隐藏；后台标签不轮询，避免多余请求。
 * 仅返回过滤后的视图，原项目数据继续留在全局供详情、财务及复工操作使用。
 */
import { useEffect, useMemo } from "react";
import { isEngineeringProjectVisible } from "../lib/engineeringVisibility";

export function useEngineeringProjects(projects, refreshProjects) {
  useEffect(() => {
    if (!refreshProjects) return undefined;
    let busy = false;
    const sync = async () => {
      if (document.visibilityState === "hidden" || busy) return;
      busy = true;
      try { await refreshProjects(); } finally { busy = false; }
    };
    sync();
    const timer = setInterval(sync, 60000);
    window.addEventListener("focus", sync);
    document.addEventListener("visibilitychange", sync);
    return () => {
      clearInterval(timer);
      window.removeEventListener("focus", sync);
      document.removeEventListener("visibilitychange", sync);
    };
  }, [refreshProjects]);
  return useMemo(() => projects.filter(isEngineeringProjectVisible), [projects]);
}
